import { extractPrimitiveValue } from './extractPrimitiveValue';
export const createAnalyticsChartData = ({ reportData, activeSeries, }) => {
    if (!reportData?.report) {
        return [];
    }
    const data = {
        label: '',
        data: reportData.report.rows.map((row) => {
            const seriesProperty = row[activeSeries];
            return {
                value: extractPrimitiveValue(seriesProperty),
                label: Object.values(row)[0],
            };
        }),
    };
    return [data];
};
